// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import CaretDown from "@store/Library/Components/Icons/CaretDown";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const select: Styleguide["select"] = {
    defaultProps: {
        /* Store Custom Code - Start */
        iconProps: {
            src: CaretDown,
            css: css`
                svg {
                    width: ${pxToRem(26)};
                    height: ${pxToRem(26)};
                }
            `,
        },
        /* Store Custom Code - End */
        css: css`
            &&:not(.selected)[data-selected-index=""] {
                color: ${getColor("placeholder")};

                &:disabled,
                &.disabled {
                    color: ${getColor("placeholder.disabled")};
                }
            }

            option {
                color: ${getColor("text.input")};

                select:not(.selected) &[value=""] {
                    color: ${getColor("placeholder")};
                }

                &:disabled {
                    background-color: ${x => getColor("common.disabled")};
                    color: ${getColor("text.disabled")};
                }
            }
        `,
    },
};

export default select;
